export default "__VITE_ASSET__DAM_5$Kz__"